export default __webpack_public_path__ + "static/media/pcAi@2x.ead0036f.png";